import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 17 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M12.2 1.853a.67.67 0 0 0-.666-.52H4.867a.67.67 0 0 0-.667.52l-1.333 6a.667.667 0 0 0 .667.814H6.16q.04.332.04.666a5.95 5.95 0 0 1-1.713 4.2.667.667 0 0 0 .473 1.134h6.48a.667.667 0 0 0 .474-1.134 5.95 5.95 0 0 1-1.673-4.866h.626V10a.667.667 0 0 0 1.333 0V8.667h.667a.667.667 0 0 0 .653-.814zm-5.853 11.48a7.27 7.27 0 0 0 1.187-4c0-.22 0-.446-.034-.666h1.4c0 .22-.033.446-.033.666a7.27 7.27 0 0 0 1.187 4zm-2-6L5.4 2.667H11l1.034 4.666z"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })